import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OpcionesService, PanelItemOpcionesVM } from '../../infrastructure/services/opciones.service';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';

@Component({
  templateUrl: 'seleccionar.nivel.consultaSimple.component.html'
})
export class SeleccionarNivelConsultaSimpleComponent implements OnInit {
  constructor(private aRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }
  volver() {
      this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/consultaSimple/seleccionar.nivel.consultaSimple.component.ts